import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import makeAppURL from '../../../../utils/makeAppURL'
import {CopyServiceProviderURL} from './CopyServiceProviderURL'





const OrgAuthenticationSignOutUrl = (props) => {
  const {samlRef} = props
  const saml = useFragment(
    graphql`
      fragment OrgAuthenticationSignOnUrl_saml on SAML {
        id
      }
    `,
    samlRef
  )
  const domain = _nullishCoalesce(_optionalChain([saml, 'optionalAccess', _ => _.id]), () => ( 'XXXX-XXXX'))
  const startURL = window.location.origin
  const acsURL = makeAppURL(startURL, `/saml/${domain}`)
  const entityId = makeAppURL(startURL, `/saml-metadata/${domain}`)
  return (
    _jsxs(_Fragment, { children: [
      _jsxs('div', { className: "px-6 pb-3" , children: [
        _jsx('div', { className: "flex text-base leading-6 font-semibold text-slate-700"    , children: "Set up your Identity Provider"

        })
        , _jsx('div', { className: 'flex items-center text-sm text-slate-700', children: "Paste the following URLs into your Identity Provider’s SAML configuration"

        })
      ]})
      , _jsxs('div', { className: "column-ga grid grid-cols-[max-content_fit-content(300px)_24px] items-center gap-x-2 px-6 pb-8"      , children: [
        _jsx(CopyServiceProviderURL, { url: acsURL, label: 'ACS URL',} )
        , _jsx(CopyServiceProviderURL, { url: entityId, label: 'Entity ID',} )
        , _jsx(CopyServiceProviderURL, { url: startURL, label: 'Start URL',} )
      ]})
    ]})
  )
}

export default OrgAuthenticationSignOutUrl
